import React from 'react';
import styled, { keyframes } from 'styled-components';

const Spinning = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const Stator = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

const Rotor = styled.img`
  animation: ${Spinning} infinite 0.75s linear;
  height: 80px;
  margin: 0 auto;
`;

const Spinner = () => (
  <Stator>
    <Rotor src="/spinner.png" />
  </Stator>
);

export default Spinner;
